import { atom } from 'jotai';

export const swUpdateAvailableAtom = atom(false);
